// blakfy-cookie/src/i18n/translations/cs.js — Czech translations

export default {
  title: "Předvolby souborů cookie",
  intro:
    "Tento web používá soubory cookie ke zlepšení vašeho zážitku. Viz naše Zásady souborů cookie.",
  policyLink: "Zásady souborů cookie",
  acceptAll: "Přijmout vše",
  rejectAll: "Odmítnout vše",
  preferences: "Předvolby",
  save: "Uložit volby",
  close: "Zavřít",
  cat: {
    essential: {
      title: "Nezbytné soubory cookie",
      desc: "Nutné pro fungování webu. Nelze je deaktivovat.",
      always: "Vždy aktivní",
    },
    analytics: {
      title: "Analytické soubory cookie",
      desc: "Slouží ke shromažďování anonymních statistik návštěv.",
    },
    marketing: {
      title: "Marketingové soubory cookie",
      desc: "Slouží k personalizované reklamě a retargetingu.",
    },
    functional: {
      title: "Funkční soubory cookie",
      desc: "Slouží k zapamatování předvoleb jako jazyk a téma.",
    },
  },
  placeholder: {
    title: "Obsah blokován",
    desc: "Pro zobrazení tohoto obsahu musíte povolit soubory cookie {category}.",
    cta: "Povolit",
  },
  tabs: {
    categories: "Categories",
    services: "Services",
    about: "About",
  },
  service: {
    description: "Description",
    processor: "Data Processor",
    address: "Address",
    dpo: "DPO Contact",
    purposes: "Purposes",
    technologies: "Technologies Used",
    dataCollected: "Data Collected",
    legalBasis: "Legal Basis",
    retention: "Retention Period",
    transferCountries: "Transfer Countries",
    privacyPolicy: "Privacy Policy",
    cookiePolicy: "Cookie Policy",
    legalBasisValues: {
      consent: "Consent (Art. 6 para. 1 s. 1 lit. a GDPR)",
      legitimate_interest: "Legitimate Interest (Art. 6 para. 1 s. 1 lit. f GDPR)",
    },
    noServices: "No services are configured for this site.",
  },
  svcAbout: {
    title: "About this CMP",
    description:
      "This website uses Blakfy Cookie Management Platform (CMP) to manage your consent preferences in compliance with GDPR, KVKK, CCPA and other applicable privacy regulations.",
    version: "Version",
    learnMore: "Learn more at blakfy.com",
  },
};
